import { createPortal } from "react-dom";
import { useTranslation } from "react-i18next";
import { Share2, X } from "lucide-react";
import { toast } from "sonner";
import { shareFile } from "../../native/shareFile";
import { DocScroll } from "./DocScroll";
import { PdfView } from "./PdfView";

const isPdf = (u = "") => /\.pdf(\?|$)/i.test(u);
const extOf = (u = "") => (u.split("?")[0].match(/\.([a-z0-9]{2,5})$/i)?.[1] || "pdf").toLowerCase();
const safeName = (title, u) => `${(title || "document").replace(/[\\/:*?"<>|]+/g, "-").trim()}.${extOf(u)}`;

export const DocViewer = ({ open, url, title, onClose }) => {
  const { t } = useTranslation();
  if (!open || !url) return null;
  const share = async () => {
    try { await shareFile(url, safeName(title, url)); }
    catch { toast.error(t("errors.generic")); }
  };
  const btn = "flex h-11 w-11 items-center justify-center rounded-full bg-black/60 text-white backdrop-blur transition hover:bg-black/80";
  const node = (
    <div className="fixed inset-0 z-[70] overflow-hidden bg-black" data-testid="doc-viewer">
      <div className="absolute start-3 top-[max(0.75rem,env(safe-area-inset-top))] z-[80] flex gap-2">
        <button type="button" data-testid="doc-viewer-close" onClick={onClose} aria-label={t("empDocs.close")} title={t("empDocs.close")} className={btn}>
          <X className="h-5 w-5" />
        </button>
        <button type="button" data-testid="doc-viewer-share" onClick={share} aria-label={t("empDocs.share")} title={t("empDocs.share")} className={btn}>
          <Share2 className="h-5 w-5" />
        </button>
      </div>
      <DocScroll>
        {isPdf(url) ? (
          <PdfView url={url} title={title} />
        ) : (
          <img src={url} alt={title} className="w-full max-w-3xl rounded-lg" data-testid="doc-viewer-image" draggable={false} />
        )}
      </DocScroll>
    </div>
  );
  return createPortal(node, document.body);
};
